export var notificationWarningAlt = [
    'M9.52 11.44C9.52 10.58 8.82 9.88 7.96 9.88C7.08 9.88 6.4 10.58 6.4 11.44C6.4 12.32 7.08 13 7.96 13C8.82 13 9.52 12.32 9.52 11.44ZM6.58 3.51L6.83 8.82C6.85 9.05 7.06 9.25 7.3 9.25H8.61C8.84 9.25 9.06 9.05 9.08 8.82L9.33 3.51C9.35 3.23 9.13 3 8.86 3H7.04C6.77 3 6.56 3.23 6.58 3.51Z',
];
